export const setDefaultUserData = () => dispatch => {
	// dispatch(retrieveUsers({ page: 1 }))
}